// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/visibility',
    name: 'Visibility',
    component: layout,
    redirect: '/visibility/index',
    meta: {
      title: '可见度排名',
      icon: 'i-menu:visibility',
      i18Key: 'router.user.visibility.title',
      roles: [1]
    },
    sort: 51,
    children: [
      {
        path: 'index',
        name: 'VisibilityIndex',
        component: () => import('@/views/Visibility/Index.vue'),
        meta: {
          title: '可见度排名',
          icon: 'visibility',
          iconIsComponent: true,
          i18Key: 'router.user.visibility.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtn', 'questionBtn'],
          isAdvanced: true
        }
      }
    ]
  }
]
export default routes
